import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getLedgerEntries, postJournal } from "@/services/ledger.service";

export const useLedgerEntries = (
  accountNumber,
  environment,
  params = {},
  options = {},
) =>
  useQuery({
    queryKey: [
      "ledger-entries",
      environment,
      accountNumber,
      params.page,
      params.size,
    ],
    queryFn: () =>
      getLedgerEntries({
        accountNumber,
        environment,
        page: params.page,
        size: params.size,
      }),
    enabled: Boolean(accountNumber && environment),
    // No keepPreviousData: lets isLoading drive the table skeleton on page change.
    ...options,
  });

export const usePostJournal = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: postJournal,
    onSuccess: (_data, variables) => {
      // Refresh both balances and the entries history after a successful post.
      queryClient.invalidateQueries({
        queryKey: ["ledger-account", variables.environment],
      });
      queryClient.invalidateQueries({
        queryKey: ["ledger-entries", variables.environment],
      });
      queryClient.invalidateQueries({
        queryKey: ["ledger-accounts", variables.environment],
      });
    },
  });
};
